import { useContext, useEffect, useState, useSyncExternalStore } from "react"
import { Circle, CircleMarker, LayerGroup, Polyline } from "react-leaflet"
import { dynamicPositionStore } from "./dynamicPositionStore"
import { AuthProvider } from "../globalContext"
import { PositionData } from "./position-data"

interface HistoryPoint{
    _id: string,
    last_seen: string
    position: string
}

function lerp(a: number, alpha: number, b: number): number{
    return a + alpha * (b-a)
}

export function HistoryLayer(props: any){
    // Update (rerender once ID has changed)
    
    // TODO: remove htis, use outer ID?
    const {id: userID} = useContext(AuthProvider)

    const params = new URLSearchParams(window.location.search)
    const player = params.get("userId")

    const id = player ?? userID

    // TODO: change to proper 
    const [history, setHistory] = useState<[number, number][]>([])
    const max_size : number= 5
    const min_size : number= 2
    const start_color = {r: 205, g: 10, b: 10};
    const end_color = {r: 100, g: 100, b: 100};

    // TODO: ask ania, if use explicit on button focus select (from profile)
    //* and ask if to set update on this component, if everyone will be using that, the server will slow-down
    // 1. Fetch data from server?
    useEffect(()=>{
        fetch(`/api/map/history/${id}`).then(r => r.json()).then(d => 
            {if(d){
                let pos : [number, number][] = d.map((e: HistoryPoint)=>{
                    let coords : PositionData = JSON.parse(e.position)
                    return coords.coords
                })
                setHistory(pos)
            }})
    },[])
            return (
    <LayerGroup>
        {
            history.map((pos,i)=>{
                let alpha = Math.exp(i/history.length - 1)
                let size = lerp(min_size, alpha, max_size)
                let r = lerp(end_color.r, alpha, start_color.r)
                let g = lerp(end_color.g, alpha, start_color.g)
                let b = lerp(end_color.b, alpha, start_color.b)
                return <CircleMarker center={pos} interactive={false} key={i} color={`rgb(${r}, ${g}, ${b})`} fillOpacity={0.7} opacity={0.7} radius={size}></CircleMarker>
            })
        }
        <Polyline positions={history} color="gray" interactive={false} weight={3} opacity={0.5} smoothFactor={1}></Polyline>
    </LayerGroup>
  )
}